import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { GoNApp } from './app.component';
import { FirebaseService } from '../providers/firebase-service';

@NgModule({
  declarations: [
    GoNApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(GoNApp),
    AngularFireModule.initializeApp({
      "apiKey" : "AIzaSyBN3xYOSkEryEZU58zcvGlBky0KT6AX1kQ",
      "authDomain" : "kiwicube-puchuhandsup.firebaseapp.com",
      "databaseURL" : "https://kiwicube-puchuhandsup.firebaseio.com",
      "projectId" : "kiwicube-puchuhandsup",
      "storageBucket" : "kiwicube-puchuhandsup.appspot.com",
      "messagingSenderId" : "424074346358"
    }),
    AngularFireDatabaseModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    GoNApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    FirebaseService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts